/**
 * @flow
 * @relayHash f34ad3fd548b64a228998a6b54e29776
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FactsetContractList_viewer$ref = any;
export type FactsetContractListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  isin?: ?string,
|};
export type FactsetContractListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FactsetContractList_viewer$ref
  |}
|};
export type FactsetContractListQuery = {|
  variables: FactsetContractListQueryVariables,
  response: FactsetContractListQueryResponse,
|};
*/


/*
query FactsetContractListQuery(
  $first: Int
  $offset: Int
  $search: String
  $isin: String
) {
  viewer {
    ...FactsetContractList_viewer_7kEXr
    id
  }
}

fragment FactsetContractList_viewer_7kEXr on Query {
  factsetContracts(first: $first, offset: $offset, search: $search, isin: $isin) {
    edges {
      node {
        id
        sedol
        isin
        fsExchange {
          id
          exchangeCode
          symbol
        }
        name
        fsId
        country
        industry
        sector
        exchangeSymbol
        fsymId
        lotSize
        currency
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isin",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "isin",
    "variableName": "isin"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FactsetContractListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FactsetContractList_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FactsetContractListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "factsetContracts",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "FactsetContractNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "FactsetContractNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FactsetContractNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sedol",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isin",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fsExchange",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FactsetExchangeNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "exchangeCode",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fsId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "industry",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sector",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "exchangeSymbol",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fsymId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lotSize",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FactsetContractListQuery",
    "id": null,
    "text": "query FactsetContractListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $isin: String\n) {\n  viewer {\n    ...FactsetContractList_viewer_7kEXr\n    id\n  }\n}\n\nfragment FactsetContractList_viewer_7kEXr on Query {\n  factsetContracts(first: $first, offset: $offset, search: $search, isin: $isin) {\n    edges {\n      node {\n        id\n        sedol\n        isin\n        fsExchange {\n          id\n          exchangeCode\n          symbol\n        }\n        name\n        fsId\n        country\n        industry\n        sector\n        exchangeSymbol\n        fsymId\n        lotSize\n        currency\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8ee69b5a65d306739db104dd654c856b';
module.exports = node;
